// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wa_a bhk_b bhk_wb"};